import MicroModal from 'micromodal';

MicroModal.init({
  onClose: modal => modal.remove(),
  disableScroll: true,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true
});

window.MicroModal = MicroModal;